import React from 'react'
import Create from '../crud/create'
import fields from './fields'
import menuItems from './menuItems'

const CreateProduct = props => {
  return (
    <Create
// @ts-ignore
      title='Create Product'
      fields={fields}
      apiPath='admin/products'
      successRedirectPath={resource => `/ecommerce/products/${resource.id}/edit`}
      buildMenuItems={menuItems}
    />
  )
}

export default CreateProduct
